// extracted by mini-css-extract-plugin
module.exports = {"detailsGrid":"portfolioItemModal_detailsGrid__YNW2t"};